module.exports = __webpack_public_path__ + "img/img-v2.3cd6b7f.svg";